import r1 from "@/assets/review-1.jpg";
import r2 from "@/assets/review-2.jpg";
import r3 from "@/assets/review-3.jpg";
import r4 from "@/assets/review-4.jpg";
import r5 from "@/assets/review-5.jpg";
import r6 from "@/assets/review-6.jpg";

export type Review = {
  name: string;
  city: string;
  product: string;
  rating: number; // 1-5
  body: string;
  image: string;
  yearsWearing?: string;
};

export const REVIEWS: Review[] = [
  {
    name: "Elena R.",
    city: "Milan, Italy",
    product: "The Quiet Hour Biker",
    rating: 5,
    yearsWearing: "Wearing for 2 years",
    body: "I have owned more leather jackets than I care to count, and this is the first one that feels like it was made for the woman I actually am — not the woman a magazine wanted me to be. The shoulders sit perfectly. Two years in, the leather has softened into something that feels like an old letter. I will be buried in this jacket.",
    image: r1,
  },
  {
    name: "James W.",
    city: "Brooklyn, NYC",
    product: "Cognac Single Rider",
    rating: 5,
    yearsWearing: "Wearing for 18 months",
    body: "I wrote to KAKAIYS three times before ordering — about sizing, about the leather, about the stitching. Every reply came from someone who clearly cared. The jacket arrived in eight days and the moment I opened the box I knew. It smells like a real workshop. Eighteen months on, the patina alone is worth the price.",
    image: r2,
  },
  {
    name: "Amara K.",
    city: "Lagos / London",
    product: "The Tailored Leather Blazer",
    rating: 5,
    yearsWearing: "Wearing for 1 year",
    body: "I bought this for a job I was nervous about starting. I wore it on day one and I haven't stopped since. It dresses up over silk and dresses down over a tee. The fact that one piece holds an entire wardrobe together is exactly why this brand exists.",
    image: r3,
  },
  {
    name: "Priya S.",
    city: "Mumbai, India",
    product: "Chocolate Moto Jacket",
    rating: 5,
    yearsWearing: "Wearing for 8 months",
    body: "What I love most isn't the leather — it's the people. When I sent in a question about whether the jacket would suit my frame, they replied with a personalised sketch. A SKETCH. The jacket itself is exquisite. But that level of care is what made me a customer for life.",
    image: r4,
  },
  {
    name: "Henrik M.",
    city: "Stockholm, Sweden",
    product: "Vintage Black Rider",
    rating: 5,
    yearsWearing: "Wearing for 4 years",
    body: "I am 64. I have been wearing leather jackets since I was 19. This is the best one I have ever owned, and I have owned the famous names. The cowhide is honest, heavy, and getting better every winter. My son has already asked to inherit it.",
    image: r5,
  },
  {
    name: "Sofia D.",
    city: "Barcelona, Spain",
    product: "Oxblood Burgundy Moto",
    rating: 5,
    yearsWearing: "Wearing for 6 months",
    body: "The colour photographs cannot do justice to this jacket. In person it shifts from oxblood to deep burgundy depending on the light. Strangers stop me on the street. The fit is perfect — I sent my measurements and it arrived as if it were made for me. Because, of course, it was.",
    image: r6,
  },
];
